<template>
  <div>
    <v-card>
      <CreateStudentDialog :state="dialog" :exam="query.exam" @closeDialog="close" @refresh="refresh" />
      <StudentUpdateDialog
        :state="updateDialog"
        :item="item"
        :rooms="rooms"
        :subjects="subjects"
        @closeDialog="closeUpdate"
      />
      <RemoveStudentDialog :state="deleteDialog" :item="item" @refresh="refresh" @closeDialog="closeDelete" />
      <ConfirmCreateAllDialog
        :state="confirmDialog"
        :exam="query.exam"
        :subjectGroups="subjectGroups"
        @closeDialog="closeConfirm"
        @refresh="refresh"
      />
      <AssignAllSubjectGroup
        :state="defaultDialog"
        :exam="query.exam"
        :subjectGroups="subjectGroups"
        @closeDialog="closeDefault"
        @refresh="refresh"
      />
      <div class="d-flex justify-end align-center">
        <div class="d-flex justify-start align-center pt-6 pl-6">
          <v-btn color="primary" class="elevation-0 mr-6" dark @click="openConfirm" @closeDialog="closeConfirm">
            <v-icon left>mdi-plus</v-icon>Thêm học sinh theo lớp</v-btn
          >
          <v-btn
            color="primary"
            class="elevation-0 mr-6"
            dark
            @click="openDefaultSubjectGroups"
            @closeDialog="closeDefault"
          >
            <v-icon left>mdi-plus</v-icon>Đặt tổ hợp môn</v-btn
          >
        </div>

        <v-spacer></v-spacer>
        <div class="d-flex justify-end align-center pr-6 pt-6">
          <v-btn color="primary" class="elevation-0" dark @click="openCreate">
            <v-icon left>mdi-plus</v-icon>Thêm học sinh</v-btn
          >
        </div>
      </div>

      <div>
        <ExportStudent :exam="query.exam" :query="query" @refresh="refresh" />
      </div>
      <div style="display: flex; justify-content: flex-end; margin-right: 24px">
        <ExportRegister :exam="query.exam" :query="query" :subjectGroups="subjectGroups" @refresh="refresh" />
        <v-spacer></v-spacer>
        <div>
          <div class="d-flex justify-end align-center">
            <v-spacer></v-spacer>
            <div class="d-flex justify-end align-center ">
              <!-- <div class="mr-6">
                <v-btn outlined color="primary" style="margin-top: 24px" @click="printMany">
                  <v-icon left>mdi-printer</v-icon> In toàn bộ thẻ học sinh
                </v-btn>
              </div> -->
              <v-menu v-model="showColumnSelector" offset-x :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-btn outlined v-on="on" color="primary" style="margin-top: 24px"> Cấu hình bảng </v-btn>
                </template>

                <v-list class="scrollable-menu">
                  <v-list-item v-for="(header, index) in headers" :key="index">
                    <v-list-item-action>
                      <v-checkbox v-model="header.show"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>{{ header.text }}</v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
      </div>
      <div class="pa-6">
        <v-card outlined>
          <v-data-table
            item-key="id"
            :headers="visibleHeaders"
            :loading="loading"
            :items="students"
            :items-per-page="pagination.itemsPerPage"
            :page.sync="pagination.page"
            :server-items-length="pagination.totalItems"
            :disable-sort="$vuetify.breakpoint.smAndDown"
            :footer-props="{ 'items-per-page-text': 'Số học sinh mỗi trang' }"
            :height="400"
            v-bind="this.$attrs"
            fixed-header
            @pagination="updatePagination"
          >
            <template v-slot:[`footer.page-text`]="items">
              Học sinh thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} học sinh
            </template>
            <template v-slot:[`item.create`]="{ item }">
              <div style="height: 100%">
                <StudentCreateCard :item="item.student" />
              </div>
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <div style="height: 100%">
                <StudentNameCard :item="item.student" />
              </div>
            </template>
            <template v-slot:[`item.exam`]="{ item }">
              <div style="height: 100%">
                <StudentRoomCard :item="item" :subjects="subjects" :rooms="rooms" :exam="query.exam" />
              </div>
            </template>
            <template v-slot:[`item.extra`]="{ item }">
              <div style="height: 100%">
                <StudentExtraCard :item="item.student" />
              </div>
            </template>
            <template v-slot:[`item.contact`]="{ item }">
              <div style="height: 100%">
                <StudentContactCard :item="item.student" />
              </div>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              {{ item | getStatus }}
            </template>
            <template v-slot:[`item.subjectGroups`]="{ item }">
              {{ item | getSubjectGroups }}
            </template>
            <template v-slot:[`item.examCode`]="{ item }">
              {{ item.examCode || '-' }}
            </template>
            <template v-slot:[`item.class`]="{ item }">
              {{ item | getClass }}
            </template>
            <template v-slot:[`item.student.code`]="{ item }">
              {{ item.student.code || '-' }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div>
                <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" @click="print(item)" v-bind="attrs" v-on="on" icon>
                      <v-icon> mdi-printer </v-icon>
                    </v-btn>
                  </template>
                  <span>In thẻ học sinh</span>
                </v-tooltip> -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" @click="update(item)" v-bind="attrs" v-on="on" icon>
                      <v-icon> mdi-pencil </v-icon>
                    </v-btn>
                  </template>
                  <span>Chỉnh sửa thông tin học sinh</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" @click="remove(item)" v-bind="attrs" v-on="on" icon>
                      <v-icon> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Bỏ học sinh khỏi kỳ kiểm tra</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-card>
    <!-- <StudentExamPrint ref="printSingleStudent" />
    <StudentExamPrintMany ref="printManyStudents" /> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import StudentCreateCard from './StudentCreateCard.vue'
import StudentNameCard from './StudentNameCard.vue'
import StudentExtraCard from './StudentExtraCard.vue'
import StudentContactCard from './StudentContactCard.vue'
import CreateStudentDialog from './CreateStudentDialog.vue'
import StudentRoomCard from './StudentRoomCard.vue'
import ConfirmCreateAllDialog from './ConfirmCreateAllDialog.vue'
import StudentUpdateDialog from './StudentUpdateDialog.vue'
import ExportStudent from './ExportStudent.vue'
import ExportRegister from './ExportRegister.vue'
import RemoveStudentDialog from './RemoveStudentDialog.vue'
import AssignAllSubjectGroup from './AssignAllSubjectGroup.vue'
// import StudentExamPrint from './StudentExamPrint.vue'
// import StudentExamPrintMany from './StudentExamPrintMany.vue'

const originHeaders = [
  {
    text: 'Thông tin học sinh',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Lớp',
    value: 'class',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Mã hồ sơ',
    value: 'student.code',
    align: 'left',
    sortable: false,
    show: true,
    width: '10%'
  },
  {
    text: 'Số báo danh',
    value: 'examCode',
    align: 'left',
    sortable: false,
    show: true,
    width: '10%'
  },
  {
    text: 'Tổ hợp môn',
    value: 'subjectGroups',
    align: 'left',
    sortable: false,
    show: true,
    width: '10%'
  },
  {
    text: 'Trường',
    value: 'student.school',
    align: 'left',
    sortable: false,
    show: false,
    width: '12%'
  },
  {
    text: 'Thông tin liên lạc',
    value: 'contact',
    align: 'left',
    sortable: false,
    show: false,
    width: '12%'
  },
  {
    text: 'Trạng thái',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true,
    width: '12%'
  },
  {
    text: 'Thông tin kiểm tra',
    value: 'exam',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Thông tin tạo',
    value: 'create',
    align: 'left',
    sortable: false,
    show: false,
    width: '20%'
  },
  {
    text: 'Thao tác',
    value: 'actions',
    align: 'left',
    sortable: false,
    show: true,
    width: '10%'
  }
]

export default {
  props: {
    query: Object,
    subjects: Array,
    rooms: Array,
    type: String,
    grade: String,
    subjectGroups: Array,
    products: Array
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      dialog: false,
      updateDialog: false,
      deleteDialog: false,
      confirmDialog: false,
      subjectGroupDialog: false,
      defaultDialog: false,
      showColumnSelector: false,
      students: [],
      item: {},
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0
      }
    }
  },
  computed: {
    visibleHeaders() {
      return this.headers.filter(header => {
        return header.show
      })
    }
  },
  methods: {
    ...mapActions('studentExam', ['fetchStudentExams', 'countStudentExams']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      const start = (this.pagination.page - 1) * this.pagination.itemsPerPage
      const limit = this.pagination.itemsPerPage
      try {
        this.pagination.totalItems = await this.countStudentExams(this.query)
        this.students = await this.fetchStudentExams({
          _start: start,
          _limit: limit,
          ...this.query,
          _sort: 'examCode:ASC'
        })
      } catch (error) {
        this.$alert.error('Lỗi load thông tin học sinh')
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    updatePagination(val) {
      this.pagination.page = val.page
      this.pagination.itemsPerPage = val.itemsPerPage
    },
    update(item) {
      this.item = item
      this.updateDialog = true
    },
    remove(item) {
      this.item = item
      this.deleteDialog = true
    },
    openCreate() {
      this.dialog = true
    },
    openConfirm() {
      this.confirmDialog = true
    },
    openSubjectGroups() {
      this.subjectGroupDialog = true
    },
    openDefaultSubjectGroups() {
      this.defaultDialog = true
    },
    close() {
      this.dialog = false
    },
    closeUpdate() {
      this.refresh()
      this.updateDialog = false
    },
    closeDelete() {
      this.deleteDialog = false
    },
    closeConfirm() {
      this.confirmDialog = false
    },
    closeSubjectGroups() {
      this.subjectGroupDialog = false
    },
    closeDefault() {
      this.defaultDialog = false
    },
    print() {
      this.$refs['printSingleStudent'].exportPDF()
    },
    printMany() {
      this.$refs['printManyStudents'].exportPDF()
    }
  },
  watch: {
    'pagination.page'() {
      this.refresh()
    },
    'pagination.itemsPerPage'() {
      this.refresh()
    },
    query: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refresh()
        }
      }
    },
    grade: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          console.log(this.grade, this.type)
        }
      }
    }
  },
  filters: {
    getStatus: item => {
      if (item.status === 'seated') {
        return 'Đã xếp'
      } else if (item.status === 'notSeated') {
        return 'Chưa xếp'
      } else if (item.status === 'seating') {
        return 'Đang xếp'
      } else {
        return '-'
      }
    },
    getClass: item => {
      if (!item.class || !item.class.title) {
        return '--'
      }
      return item.class.title
    },
    getSubjectGroups: item => {
      if (Array.isArray(item.subjectGroups) && item.subjectGroups.length > 0) {
        return item.subjectGroups.map(subjectGroup => subjectGroup.name).join(', ')
      }
      return '--'
    }
  },
  components: {
    StudentCreateCard,
    StudentNameCard,
    StudentExtraCard,
    StudentContactCard,
    CreateStudentDialog,
    StudentRoomCard,
    ConfirmCreateAllDialog,
    StudentUpdateDialog,
    ExportStudent,
    ExportRegister,
    RemoveStudentDialog,
    AssignAllSubjectGroup
    // StudentExamPrint,
    // StudentExamPrintMany
  }
}
</script>
